export default {
  authUser: JSON.parse(localStorage.getItem('authUser')),
  access_token: localStorage.getItem('access_token'),
  refresh_token: localStorage.getItem('refresh_token'),
  last_route: localStorage.getItem('last_route'),
  actAsOriginalAuthUser :JSON.parse(localStorage.getItem('actAsOriginalAuthUser')),
  isUserLoggedIn: ({ state }) => { return state.access_token && state.authUser.isAuthenticated },
  isUserLoggedInActAs:({state}) => { return Boolean(state.actAsOriginalAuthUser) }
}
